import { Link } from "react-router-dom";

export const MiningEquipmentLink = () => (
  <Link data-testid="mining-back-to-equipment-link" to="/equipment" className="flex w-full items-center justify-center border border-amber-900/50 bg-zinc-950 px-4 py-3 text-xs font-cinzel uppercase tracking-[0.16em] text-amber-300 transition-colors hover:border-amber-500 hover:bg-amber-950/30 sm:w-auto">
    Back to Equipment
  </Link>
);